const {DebounceInput} = require('./Component');


module.exports = DebounceInput;
